import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Grid } from 'semantic-ui-react';

// TODO remove negative margin from grid in semantic
var Footer = /*#__PURE__*/function (_React$Component) {
  _inherits(Footer, _React$Component);
  var _super = _createSuper(Footer);
  function Footer() {
    _classCallCheck(this, Footer);
    return _super.apply(this, arguments);
  }
  _createClass(Footer, [{
    key: "getContainerClassNames",
    value: function getContainerClassNames() {
      var _this$props = this.props,
        className = _this$props.className,
        backgroundColor = _this$props.backgroundColor;
      return this.isInColorPalette() ? "".concat(className && "".concat(className, " "), "footer-container-").concat(backgroundColor) : '';
    }
  }, {
    key: "getContainerStyle",
    value: function getContainerStyle() {
      var backgroundColor = this.props.backgroundColor;
      return !this.isInColorPalette() && backgroundColor !== 'none' ? {
        backgroundColor: backgroundColor
      } : {};
    }
  }, {
    key: "isInColorPalette",
    value: function isInColorPalette() {
      var backgroundColor = this.props.backgroundColor;
      return backgroundColor === 'primary' || backgroundColor === 'secondary';
    }
  }, {
    key: "renderFooterColumns",
    value: function renderFooterColumns() {
      var _this$props2 = this.props,
        columns = _this$props2.columns,
        verticalAlign = _this$props2.verticalAlign,
        horizontalAlign = _this$props2.horizontalAlign;
      return /*#__PURE__*/React.createElement(Grid, {
        columns: columns.length,
        verticalAlign: verticalAlign,
        textAlign: horizontalAlign,
        stackable: true
      }, columns.map(function (column, index) {
        return /*#__PURE__*/React.createElement(Grid.Column, {
          key: index
        }, column);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: this.getContainerClassNames(),
        style: this.getContainerStyle()
      }, this.renderFooterColumns());
    }
  }]);
  return Footer;
}(React.Component);
export { Footer as default };
Footer.defaultProps = {
  backgroundColor: '',
  className: '',
  columns: [],
  horizontalAlign: 'center',
  verticalAlign: 'middle'
};
Footer.propOptions = {
  backgroundColor: ['primary', 'secondary', 'default']
};